import _, { forEach } from 'lodash';
export default {
	state : {
		ticket_list: [],
		ticket_transport_return: false,
		ticket_transport_filter: {
	    trip_type: 'one_away',
	    from: {},
	    to: {},
	    departure: new Date(),
	    return: new Date()
	  },
		ticket_filter:{
			transport:{
				from: {},
				to: {},
				departure: new Date(),
	    	return: new Date(),
				is_return: false
			}
		},
	  trx_ticket:{
	    visit_date: new Date(),
	    visitor_details: {
        title: "",
				first_name: "",
        last_name: "",
        phone_number: "",
        email: ""
			},
			customer_details: {
        title: "",
				first_name: "",
        last_name: "",
        phone_number: "",
        email: ""
			},
	    ticket_details: [],
	    ticket_owner: "me",
	    payment_details: {
	      payment_type: ""
	    },
	    qty: 0,
			promo_code: '',
			product_special: {}
	  },
		trx_ticket_transport:{
			departure:{
				product:{},
				variant: []
			},
			return:{}
		},
	  trx_ticket_payment: {
	    type: '',
	    data: {}
	  },
		ticket_avb: [],
		ticket_header_menu:{
			review: false,
			gallery: false
		},
    ticketTransactionResult: {
      inquiry: {}, 
      payment: {},
      selectedProduct: [],
      promotion: {}
    }
	},
	getters: {
		getTicketCart: state => state.trx_ticket,
		getTicketTransportCart: state => state.trx_ticket_transport,
		getTicketHeaderMenu: state => state.ticket_header_menu,
		isTicketTransportCartDeparture: (state) => {
			return state.trx_ticket_transport.departure.product.id ? true : false
		},
		isTicketTransportCartReturn: (state) => {
			return state.trx_ticket_transport.return.id ? true : false
		},
	  getTicketList: state => state.ticket_list,
		getTicketFilterTransport: state => state.ticket_filter.transport,
	  getTicketCartSubTotal: function (state) {
	    let sub_total = 0
	    for (let i = 0; i < state.trx_ticket.ticket_details.length; i++) {

	      for (let j = 0; j < state.trx_ticket.ticket_details[i].variant.length; j++) {

	        sub_total += (state.trx_ticket.ticket_details[i].variant[j].qty * parseFloat(state.trx_ticket.ticket_details[i].variant[j].data.price_sell));

	      }

	    }

	    return sub_total
	  },
		getTicketSubTotalPrice: (state) => {
			let total = 0
			let ticket_list = state.trx_ticket.ticket_details
			ticket_list.forEach(product => {
				product.variant.forEach(variant=> {
					total += (variant.data.best_price.price_sell*variant.qty)
				})
			});
			return total
		},
		getTicketDiscountPrice: (state) => {
			let total = 0
			let ticket_list = state.trx_ticket.ticket_details
			ticket_list.forEach(product => {
				product.variant.forEach(variant=> {
					if(variant.data.best_price.best_price.promotion_price < 0){
						total += (Math.abs(variant.data.best_price.best_price.promotion_price)*variant.qty)
					}
				})
			});
			return total
		},
		getTicketTotalPrice: (state) => {
			let total = 0
			let ticket_list = state.trx_ticket.ticket_details
			ticket_list.forEach(product => {
				product.variant.forEach(variant=> {
					total += (variant.data.best_price.best_price.final_price*variant.qty)
				})
			});
			return total
		},
	  getTicketPayment: state => state.trx_ticket_payment,
	  getTicketFilter: state => state.ticket_transport_filter,
	  getTicketTransportReturn: state => state.ticket_transport_return,
		getTicketAvb: state => state.ticket_avb,
    getTicketTransactionResult: state => state.ticketTransactionResult
	},
	mutations: {
		ticketListAdd(state, payload) {
	    state.ticket_list = payload
	  },

	  ticketListPush(state, payload) {
	  	if(payload.type == 'reset'){
	  		let copied_data = Object.assign({}, state.ticket_list)
	  		state.ticket_list = []
	  		state.ticket_list.push(copied_data[0]) 
	  	}else{
		  	for(let i = 0; i < payload.data.length; i++){
		    	state.ticket_list.push(payload.data[i])
		  	}
	  	}
	  },

	  ticketAddItem(state, payload) {
			let ticket_detail = state.trx_ticket.ticket_details 
	    let record_ticket = ticket_detail.findIndex(ticketItem => ticketItem.ticket.id == payload.ticket.id)

			// CHANGE THE AVAILABILITY FROM MASTER
			let changeAvlbFromMaster = () => {
				if(payload.variant.use_master_availability){
					payload.variant.master_availability_reference.forEach((item,index)=>{
						let variant_in_avb = state.ticket_avb.findIndex(x=>x.id == item.reference_id)
						if(variant_in_avb != -1) state.ticket_avb[variant_in_avb].availability -= item.qty
					})
				}else{
					let variant_in_avb = state.ticket_avb.findIndex(x=>x.id == payload.variant.id)
					if(variant_in_avb != -1 && state.ticket_avb[variant_in_avb].availability > 0) state.ticket_avb[variant_in_avb].availability--
				}
			}
			
	    if (record_ticket == -1) {
				// INSERT NEW DATA 
				let new_data = {
	        ticket: payload.ticket,
	        variant: [{
						data: payload.variant,
						qty: 1,
					}]
	      }
	      state.trx_ticket.ticket_details.push(new_data)
				changeAvlbFromMaster()
	    } else {
	      let record_variant = ticket_detail[record_ticket].variant.findIndex(variantItem => variantItem.data.id == payload.variant.id)
	      if (record_variant == -1) {
					state.trx_ticket.ticket_details[record_ticket].variant.push({
						data: payload.variant,
						qty: 1,
					})
					changeAvlbFromMaster()
	      } else {
	        state.trx_ticket.ticket_details[record_ticket].variant[record_variant].qty++
					changeAvlbFromMaster()
	      }
	    }
	    state.trx_ticket.qty++
	  },
	  
	  tickcetAddItemDirect(state,payload){
	  	state.trx_ticket.ticket_details.push(payload)
	  	for(let i = 0; i < payload.variant.length; i++){
	  		state.trx_ticket.qty += payload.variant[i].qty
	  	}
	  },

	  ticketDecItem(state, payload) {
			let ticket_detail = state.trx_ticket.ticket_details 
	    let record_ticket = ticket_detail.findIndex(ticketItem => ticketItem.ticket.id == payload.ticket.id)

	    if (record_ticket != -1) {
	      let record_variant = ticket_detail[record_ticket].variant.findIndex(variantItem => variantItem.data.id == payload.variant.id)
	      if (record_variant != -1) {

					if (ticket_detail[record_ticket].variant[record_variant].qty > 1){
						state.trx_ticket.ticket_details[record_ticket].variant[record_variant].qty--
					}else {
						state.trx_ticket.ticket_details[record_ticket].variant.splice(record_variant, 1)
						if (ticket_detail[record_ticket].variant.length == 0) {
							state.trx_ticket.ticket_details.splice(record_ticket, 1);
						}
					}

					// CHANGE THE AVAILABILITY FROM MASTER
					if(payload.variant.use_master_availability){
						payload.variant.master_availability_reference.forEach((item,index)=>{
							let variant_in_avb = state.ticket_avb.findIndex(x=>x.id == item.reference_id)
							if(variant_in_avb != -1) {
								let is_new_total_bigger = state.ticket_avb[variant_in_avb].availability+item.qty > state.ticket_avb[variant_in_avb].original_availability
								if(is_new_total_bigger){
									state.ticket_avb[variant_in_avb].availability = state.ticket_avb[variant_in_avb].original_availability
								}else{
									state.ticket_avb[variant_in_avb].availability += item.qty
								}
							}
						})
					}else{
						let variant_in_avb = state.ticket_avb.findIndex(x=>x.id == payload.variant.id)
						if(variant_in_avb != -1 && state.ticket_avb[variant_in_avb].availability > 0) state.ticket_avb[variant_in_avb].availability++
					}
					
					state.trx_ticket.qty--
	      }
	    }
	  },

	  ticketClearItem(state, payload) {
	    let temp_qty = 0
	    let record_ticket = state.trx_ticket.ticket_details.findIndex(ticketItem => ticketItem.ticket.id == payload.id)
	    if (record_ticket != -1) {
				state.trx_ticket.ticket_details[record_ticket].variant.forEach(variant=>{
					temp_qty += variant.qty

					if(variant.data.use_master_availability){
						variant.data.master_availability_reference.forEach((item,index)=>{
							let variant_in_avb = state.ticket_avb.findIndex(x=>x.id == item.reference_id)
							if(variant_in_avb != -1) {
								let is_new_total_bigger = state.ticket_avb[variant_in_avb].availability+item.qty > state.ticket_avb[variant_in_avb].original_availability
								if(is_new_total_bigger){
									state.ticket_avb[variant_in_avb].availability = state.ticket_avb[variant_in_avb].original_availability
								}else{
									state.ticket_avb[variant_in_avb].availability += item.qty
								}
							}
						})
					}else{
						let variant_in_avb = state.ticket_avb.findIndex(x=>x.id == variant.data.id)
						if(variant_in_avb != -1 && state.ticket_avb[variant_in_avb].availability > 0) state.ticket_avb[variant_in_avb].availability++
					}
				})
				state.trx_ticket.ticket_details.splice(record_ticket, 1);
	      state.trx_ticket.qty -= temp_qty
	    }
	  },

	  ticketSetBookingDate(state, payload) {
	    state.trx_ticket.visit_date = payload
	  },

	  ticketResetItem(state, payload) {
	    state.trx_ticket.ticket_details = []
	    state.trx_ticket.qty = 0
			if(state.ticket_avb.length > 0){
				state.ticket_avb = state.ticket_avb.map(item=>{
					item.availability = item.original_availability
					return item
				})
			}
	    if (payload == 'with_date') {
	      state.trx_ticket.visit_date = new Date()
	    }
	  },

	  ticketSetVisitorDetail(state, payload) {
	    state.trx_ticket.visitor_details = payload
	  },

	  ticketSetOwner(state, payload) {
	    state.trx_ticket.ticket_owner = payload
	  },

	  ticketSetPayment(state, payload) {
	    state.trx_ticket_payment = payload
	  },

	  ticketSetFilter(state,payload){
	    if(payload.type == 'update'){
	      state.ticket_transport_filter = payload.data
	    }else if(payload.type == 'reset'){
	      state.ticket_transport_filter = {
	        trip_type: 'one_away',
	        from: {},
	        to: {},
	        departure: new Date(),
	        return: new Date()
	      }
	    }
	  },

	  ticketSetTransportReturn(state, payload){
	  	state.ticket_transport_return = payload
	  },

		ticketSetGuest(state,payload){
			for (let param of payload.data){
				state.trx_ticket[payload.field][param.key] = param.value
			}
		},

		ticketSetPromoCode(state,payload){
			state.trx_ticket.promo_code = payload
		},

		ticketUpdateDataCart(state,payload){
			state.trx_ticket.ticket_details = state.trx_ticket.ticket_details.map(product=>{
				let product_in_cart = payload.findIndex(x=>x.id == product.ticket.id)
				if(product_in_cart != -1){
					let new_data = _.cloneDeep(payload[product_in_cart])
					product.ticket = new_data
					product.variant = product.variant.map(variant=>{
						let variant_index = new_data.variants.findIndex(x=>x.id == variant.data.id)
						if(variant_index != -1){
							variant.data = new_data.variants[variant_index]
						}
						return variant
					})
					delete new_data.variants
				}
				return product
			})
		},

		ticketSetProductSpecial(state,payload){
			state.trx_ticket.product_special = payload
		},
		
		setTicketAvb(state,payload){
			state.ticket_avb = payload
			let ticket_list = state.trx_ticket.ticket_details
			if(ticket_list.length > 0){
				ticket_list.forEach((product,product_index)=>{
					product.variant.forEach((variant,variant_index)=>{
						let resetSelectedTicket = () =>{
							state.trx_ticket.qty -= variant.qty
							if(product.variant.length == 1) state.trx_ticket.ticket_details.splice(product_index,1) 
							else state.trx_ticket.ticket_details[product_index].variant.splice(variant_index,1)
						}

						if(variant.data.use_master_availability){
							let all_avb_reference = []
							let total_need_avb_per_product = 0
							let total_avb = 0
							
							for (let i = 0; i < variant.data.master_availability_reference.length; i++) {
								const el = variant.data.master_availability_reference[i];
								let matched_i = state.ticket_avb.findIndex(y=>y.id == el.reference_id)
								if(matched_i != -1){
									let all_avb_reference_item = {
										avb_ref: state.ticket_avb[matched_i],
										avb_i: matched_i,
										avb_child: el
									}
									total_need_avb_per_product += el.qty
									total_avb += state.ticket_avb[matched_i].availability
									all_avb_reference.push(all_avb_reference_item)
								}else{
									resetSelectedTicket()
									break;
								}
							}

							if(total_avb >= (total_need_avb_per_product*variant.qty)){
								all_avb_reference.forEach(x=>{
									state.ticket_avb[x.avb_i].availability -= (x.avb_child.qty*variant.qty)
								})
							}else{
								resetSelectedTicket()
							}
						}else{
							let record_avlb = payload.findIndex(x=>x.id == variant.data.id)
							if(record_avlb != -1){
								state.ticket_avb[record_avlb].availability -= variant.qty
							}else{
								console.log("C")
								resetSelectedTicket()
							}
						}
					})
				})
			}
		},

		setTicketFilter(state,payload){
			for(let param of payload.data){
				state.ticket_filter[payload.type][param.key] = param.value
			}
		},

		addTicketTransport(state,payload){
			if(payload.type == 'departure'){
				let is_same_product = state.trx_ticket_transport.departure.product.id && state.trx_ticket_transport.departure.product.id == payload.product.id
				if(is_same_product){
					let variant_record = state.trx_ticket_transport.departure.variant.findIndex(x=>x.data.id == payload.variant.id)
					if(variant_record != -1){
						state.trx_ticket_transport.departure.variant[variant_record].qty++
					}else{
						state.trx_ticket_transport.departure.variant.push({
							data: payload.variant,
							qty: 1
						})
					}
				}else{
					state.trx_ticket_transport.departure = {
						product: payload.product,
						variant: [
							{data: payload.variant, qty: 1}
						]
					}
				}
			}
		},

		deleteTicketTransport(state,payload){
			if(payload.type == 'departure'){
				let is_same_product = state.trx_ticket_transport.departure.product.id && state.trx_ticket_transport.departure.product.id == payload.product.id
				if(is_same_product){
					let variant_record = state.trx_ticket_transport.departure.variant.findIndex(x=>x.data.id == payload.variant.id)
					if(variant_record != -1){
						state.trx_ticket_transport.departure.variant[variant_record].qty--
						if(state.trx_ticket_transport.departure.variant[variant_record].qty == 0){
							state.trx_ticket_transport.departure.variant.splice(variant_record,1)
							if(state.trx_ticket_transport.departure.variant.length == 0){
								state.trx_ticket_transport.departure.product = {}
							}
						}
					}else{
						console.log("PRODUCT NOT FOUND")
					}
				}else{
					console.log("PRODUCT NOT FOUND")
				}
			}
		},

		resetTicketTransport(state,payload){
			if(payload == 'departure'){
				state.trx_ticket_transport.departure = {
					product:{},
					variant: []
				}
			}
		},
		
		setTicketHeaderMenu(state,payload){
			for(let param of payload){
				state.ticket_header_menu[param.key] = param.value
			}
		},

    setTicketTransactionResult(state, payload){
      const { field="inquiry", data } = payload
      state.ticketTransactionResult[field] = data;
    },
    resetTicketTransactionResult(state){
      state.ticketTransactionResult = {
        inquiry: {}, 
        payment: {},
        selectedProduct: [],
        promotion: {}
      };
    },

		resetAllDataTicket(state){
			state.ticket_list = []
			state.ticket_transport_return = false
			state.ticket_transport_filter = {
				trip_type: 'one_away',
				from: {},
				to: {},
				departure: new Date(),
				return: new Date()
			}
			state.ticket_filter = {
				transport:{
					from: {},
					to: {},
					departure: new Date(),
					return: new Date(),
					is_return: false
				}
			}
			state.trx_ticket ={
				visit_date: new Date(),
				visitor_details:  {
					title: "",
					first_name: "",
					last_name: "",
					phone_number: "",
					email: ""
				},
				customer_details:  {
					title: "",
					first_name: "",
					last_name: "",
					phone_number: "",
					email: ""
				},
				ticket_details: [],
				ticket_owner: "me",
				payment_details: {
					payment_type: ""
				},
				qty: 0,
				promo_code: '',
				product_special: {}
			}
			state.trx_ticket_transport = {
				departure:{
					product:{},
					variant: []
				},
				return:{}
			}
			state.trx_ticket_payment = {
				type: '',
				data: {}
			}
			state.ticket_avb = {}
			state.ticket_header_menu = {
				gallery: false,
				review: false
			}
      state.ticketTransactionResult = {
        inquiry: {}, 
        payment: {},
        selectedProduct: [],
        promotion: {}
      }
		}
	},
	actions: {
		ticketListAddAct({ commit }, payload) {
	    commit("ticketListAdd", payload);
	  },
	  ticketListPushAct({commit},payload){
	  	commit("ticketListPush",payload)
	  },
	  ticketAddItemCart({ commit }, payload) {
	    commit("ticketAddItem", payload);
	  },
	  ticketDecItemCart({ commit }, payload) {
	    commit("ticketDecItem", payload);
	  },
	  ticketClearItemCart({ commit }, payload) {
	    commit("ticketClearItem", payload);
	  },
	  ticketSetBookingDateCart({ commit }, payload) {
	    commit("ticketSetBookingDate", payload);
	  },
	  ticketResetItemCart({ commit }, payload) {
	    commit("ticketResetItem", payload);
	  },
	  ticketSetVisitorDetailCart({ commit }, payload) {
	    commit("ticketSetVisitorDetail", payload);
	  },
	  ticketSetOwnerCart({ commit }, payload = 'with_date') {
	    commit("ticketSetOwner", payload);
	  },
	  ticketSetPaymentDoku({ commit }, payload) {
	    commit("ticketSetPayment", payload)
	  },
	  ticketSetPaymentDoku({commit},payload){
	    commit("ticketSetPayment",payload)
	  },
	  ticketSetFilterTransport({commit},payload){
	    commit("ticketSetFilter",payload)
	  }
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/ticket.js